module.exports = __webpack_public_path__ + "img/logo.9d1eb317.png";